const orderByMap = {
    userName: "u.name",
    dtStart: "e.dt_start",
    observation: "e.data->>'observation'",
    status: "e.status",
    vehicles_count: "vehicles_count",
    individuals_count: "individuals_count",
    bo_number: "bo_number",
    id: "e.id",
};

const getFilterValue = (payload, field) => {
    return payload?.filter?.find(item => item.field === field)?.value;
};

const getPeriodDate = (date, hours, minutes, seconds, milliseconds) => {
    if (!date) return null;

    const periodDate = new Date(date);
    periodDate.setHours(hours, minutes, seconds, milliseconds);

    return periodDate;
};

const formatDateTime = (value) => {
    if (!value || (typeof value === "string" && value.includes("/"))) return value;

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return `${date.toLocaleDateString("pt-BR")} ${date.toLocaleTimeString("pt-BR", {timeStyle: "short"})}`;
};

const normalizeEncounterRow = (row) => {
    const userName = row.userName ?? "";
    const userNameWar = row.userNameWar ?? "";

    return {
        ...row,
        dtStart: formatDateTime(row.dtStart),
        userName: userNameWar && !userName.includes(`(${userNameWar})`)
            ? `${userName} (${userNameWar})`.trim()
            : userName,
    };
};

export const buildEncounterListPayload = (filters, sort) => {
    const userIds = filters.users?.map(user => `${user.value}`) ?? [];
    const filter = [
        {
            field: "plate",
            type: "like",
            value: (filters.plate || "")
                .replace(/[.*+?^${}()|[\]\\-\s]/g, "")
                .toUpperCase(),
        },
        {
            field: "cpf",
            type: "like",
            value: (filters.cpf || "")
                .replace(/[.*+?^${}()|[\]\\-\s]/g, ""),
        },
        {
            field: "status",
            type: "like",
            value: filters.status || "",
        },
        {
            field: "textContained",
            type: "like",
            value: filters.textContained?.trim() ?? "",
        },
    ];

    if (userIds.length) {
        filter.push({
            field: "users",
            type: "in",
            value: userIds,
        });
    }

    if (filters.dtStart || filters.dtEnd) {
        filter.push({
            field: "dtStart",
            type: "keywords",
            value: {
                dateStart: getPeriodDate(filters.dtStart, 0, 0, 0, 0),
                dateEnd: getPeriodDate(filters.dtEnd, 23, 59, 59, 999),
            },
        });
    }

    return {
        page: 0,
        size: 0,
        sort,
        filter,
    };
};

export const buildEncounterListHeaders = (payload) => {
    const headers = {
        page: "0",
        perPage: "999999",
    };

    const plate = String(getFilterValue(payload, "plate") ?? "")
        .replace(/[^A-Z0-9]/gi, "")
        .toUpperCase();

    const cpf = String(getFilterValue(payload, "cpf") ?? "")
        .replace(/\D/g, "");

    const status = String(getFilterValue(payload, "status") ?? "").trim();
    const textContained = String(getFilterValue(payload, "textContained") ?? "").trim();
    const users = getFilterValue(payload, "users");
    const period = getFilterValue(payload, "dtStart");
    const sort = payload?.sort?.[0];

    if (plate) headers.plate = plate;
    if (cpf) headers.cpf = cpf;
    if (status) headers.status = status;
    if (textContained) headers.textContained = textContained;

    if (Array.isArray(users) && users.length) {
        headers.userIds = JSON.stringify(users.map(user => Number(user)));
    }

    if (period?.dateStart) headers.dt_start = new Date(period.dateStart).toISOString();
    if (period?.dateEnd) headers.dt_end = new Date(period.dateEnd).toISOString();

    if (sort?.field && sort?.dir && orderByMap[sort.field]) {
        const direction = String(sort.dir).toLowerCase() === "asc" ? "asc" : "desc";
        headers.orderBy = `${orderByMap[sort.field]} ${direction}`;
    }

    return headers;
};

export const normalizeEncounterListResponse = (data) => {
    const rows = Array.isArray(data?.result)
        ? data.result
        : (Array.isArray(data?.data) ? data.data : data);

    return (Array.isArray(rows) ? rows : []).map(normalizeEncounterRow);
};
